import { Box, Table, Thead, Tbody, Tr, Th, Td, chakra, Badge, Spinner, Text, SimpleGrid, Flex, Wrap, WrapItem } from '@chakra-ui/react'
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons'
import { useTable, useSortBy } from 'react-table'
import React, { useState, useEffect } from 'react';

export default function DataTable({ columns, data, loading }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy)
  
    return (
      <>
      {loading ? <Spinner size={'lg'} thickness='3px' color={'cyan.400'}/> : (
      <Table {...getTableProps()} size={'sm'}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  isNumeric={column.isNumeric}
                >
                  {column.render('Header')}
                  <chakra.span pl='4'>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <TriangleDownIcon aria-label='sorted descending' />
                      ) : (
                        <TriangleUpIcon aria-label='sorted ascending' />
                      )
                    ) : null}
                  </chakra.span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row)
            return (
              <Tr {...row.getRowProps()} h={12}>
                {row.cells.map((cell, index) => (
                  // console.log(cell.value + index),
                  <Td key={cell.column} {...cell.getCellProps()} isNumeric={cell.column.isNumeric}>
                    {/* {console.log(row.cells[0])} */}
                      {cell.value ? 
                      typeof(cell.value) == 'object' ?
                      cell.value.length == 0 ? <Badge fontSize={11} borderRadius={30} colorScheme="gray" px={3} py={2} key={cell.value + index}><Text isTruncated>Undetermined</Text></Badge> :
                      cell.value.map(value => value.toLowerCase().includes('pathogenic') || value.toLowerCase().includes('risk') ? <Badge fontSize={11} borderRadius={30} colorScheme="red" px={3} py={2} key={cell.value + index}><Text isTruncated>{value}</Text></Badge>: <Badge key={row.cells[0].value} fontSize={11} borderRadius={30} colorScheme="orange" px={3} py={2}><Text isTruncated>{value}</Text></Badge>)
                      : cell.value
                      : null
                      // cell.value.toString().toLowerCase().includes('benign') ? 
                      // <Badge fontSize={11}  borderRadius={30} colorScheme="green" px={3} py={2}>{cell.render('Cell')}</Badge> : 
                      // cell.value.toString().toLowerCase().includes('risk') ? 
                      // <Badge fontSize={11} borderRadius={30} colorScheme="red" px={3} py={2}>{cell.render('Cell')}</Badge> : 
                      // cell.value.toString().toLowerCase().includes('carrier') ? 
                      // <Badge fontSize={11}  borderRadius={30} colorScheme="teal" px={3} py={2}>{cell.render('Cell')}</Badge> : 
                      // cell.value.toString().toLowerCase().includes('pathogenic') ? 
                      // <SimpleGrid columns={1}><Badge fontSize={11} borderRadius={30} colorScheme="red" px={3} py={2}><Text isTruncated>{cell.render('Cell')}</Text></Badge></SimpleGrid> : 
                      // cell.render('Cell') : cell.render('Cell')
                    }
                  </Td>
                ))}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
      )}
      </>
    )
  }